<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>合同信息：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="员工：" required>
              <el-select v-model="employeeData.employee_id" placeholder="姓名" filterable :disabled="isEdit" clearable>
                <el-option v-for="item in employeeList" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="合同编号：">
              <el-input v-model="employeeData.contract_name" placeholder="合同编号" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="合同类型：" required>
              <el-select v-model="employeeData.contract_type" placeholder="合同类型" clearable>
                <el-option v-for="item in contractTypeList" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="合同状态：" required>
              <el-select v-model="employeeData.contract_status" placeholder="合同状态" clearable>
                <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="签订日期：">
              <el-date-picker v-model="employeeData.contract_signed_date" type="date"
                              value-format="YYYY-MM-DD" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="合同到期⽇期：">
              <el-date-picker v-model="employeeData.contract_expire_date" type="date"
                              value-format="YYYY-MM-DD" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="合同生效⽇期：">
              <el-date-picker v-model="employeeData.contract_effect_date" type="date"
                              value-format="YYYY-MM-DD" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <h4>附件：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px">
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件：">
              <FrameItem v-model="employeeData.file_id" :file-list="file_id_obj" :item="uploadObj" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件照片：">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="">
              <FrameItem v-model="employeeData.attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" :loading="loading" @click="save" >保存</el-button>
        </el-col>
      </el-row>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'

export default {
  name: "EmployeeContract",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    statusList() {
      return this.$store.getters['core/getDictList']('contract_status');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      uploadObj: {
        component: 'file_upload',
        limit: 1,
      },
      employee_no: '',
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        entry_date: '',
        is_probation: false,
        probation_end_date: '',
        labor_company_id:'',
        employee_type:''
      },
      isEdit:false,
      isShow:false,
      photoType:'',
      dialogVisible: false,
      departmentList: [],
      contractTypeList:[],
      reasonList: [],
      employeeList:[],
      loading: false,
      fileList:[],
      attach_photo_id_obj:[],
      file_id_obj:[]
    }
  },
  methods: {
    async loadEmployeeContract() {
      let params = {id: this.parentData.id}
      this.$http('employeeContractService.getContractById', params).then(data => {
        if (data) {
          this.isEdit = true;
          this.attach_photo_id_obj = data.attach_photo_id_obj;
          this.file_id_obj = data.file_id_obj;
          this.employeeData = data;
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    //获取员工
    async getEmployee(){
      this.employeeList =await this.$http('employeeArchivesService.getDepartmentAndEmpId');
    },
    //获取员工
    async getContractType(){
      this.contractTypeList =await this.$http('employeeArchivesService.getContractInfo');
    },
    async openCameraMain(){
      this.dialogVisible = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisible = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.employeeData.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisible = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    save() {
      if (!this.employeeData) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.employee_id) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.contract_type) {
        this.$message.error("请选择合同类型");
        return;
      }
      if (!this.employeeData.contract_status) {
        this.$message.error("请选择合同状态");
        return;
      }
      this.loading = true;
      this.$http('employeeContractService.insertContract', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.employeeData.file_id = ids;
    },
  },
  created() {
    this.getContractType();
    this.getEmployee();
    this.loadEmployeeContract();
  },
}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin: 10px 0;
}

</style>